export default "__VITE_ASSET__DxQObqmA__"